module.exports = __webpack_public_path__ + "img/2-4.8d42fa99.png";